<div
    class="checkbox-container size-filter-wrapper hmf-position-relative hmf-display-flex hmf-justify-content-start hmf-flex-wrap"
    [class]="!showMore() ? 'view-more hmf-mb-xs' : 'view-less'">
    @for (
        filterOption of filterOptions();
        track trackFilterName(filterOption)
    ) {
        <button
        id="{{ isMobile() ? 'filter-mobile-' + filterOption.value : 'filter-' + filterOption.value }}"
        class="size-filter hmf-display-flex hmf-justify-content-between hmf-py-xs hmf-px-s"
        [attr.tabindex]="defaultOpen() || !allowCollapsing() ? 0 : -1"
        [class.selected]="selectedOptions()?.includes(filterOption.value)"
        [attr.aria-label]="
            filterOption.value + ', ' + filterOption.count + ' products, ' +
            (selectedOptions()?.includes(filterOption.value) ? 'selected' : 'not selected')
        "
        (click)="setSelectedFilter(filterOption.value)">
        <span class="size-filter-label">{{ filterOption.value }}</span>
        <span [attr.id]="`${isMobile() ? 'mobile-count-' : 'count-'}${attributeIdentifier()}-${filterOption.value}`">
            {{ filterOption.count | usWholeNumber }}
        </span>
        </button>
    }
</div>

@if (allowCollapsing() && hasOverflow() && filterOptions()?.length > 0) {
    <button
        hmf-action-text
        variant="secondary"
        [class.hmf-mt-s]="showMore()"
        (click)="toggleShowMore()">
        {{ !showMore() ? 'View More' : 'View Less' }}
    </button>
}
